const NOISE_CHANGE_TYPES = new Set([
  "UPDATED",
  "SOURCE_COUNT_CHANGED",
  "PRIMARY_SOURCE_CHANGED",
  "MEDIA_CHANGED",
  "PRIMARY_IMAGE_CHANGED",
]);

export function isCommercialProperty(detail) {
  return String(detail?.propertyType || "").trim().toLowerCase() === "commercial";
}

export function timelineDayKey(value) {
  if (!value) return "unknown";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "unknown";
  return date.toISOString().slice(0, 10);
}

function eventDedupeKey(event) {
  return [
    timelineDayKey(event.changedAt),
    event.changeType,
    event.newPriceMin ?? event.newPrice ?? "",
    event.previousPriceMin ?? event.previousPrice ?? "",
    event.newStatus || "",
  ].join("|");
}

export function consolidateListingTimeline(events = []) {
  const unique = [];
  const seen = new Map();

  for (const event of events) {
    if (!event) continue;
    const key = eventDedupeKey(event);
    const existing = seen.get(key);
    if (existing) {
      const sources = new Set([...(existing.sourceKeys || []), event.sourceKey].filter(Boolean));
      existing.sourceKeys = [...sources];
      if (event.entityKind === "canonical") existing.entityKind = "canonical";
      continue;
    }
    const next = {
      ...event,
      sourceKeys: event.sourceKey ? [event.sourceKey] : [],
    };
    seen.set(key, next);
    unique.push(next);
  }

  const byDay = new Map();
  for (const event of unique) {
    const key = timelineDayKey(event.changedAt);
    const list = byDay.get(key) || [];
    list.push(event);
    byDay.set(key, list);
  }

  return [...byDay.entries()]
    .sort((left, right) => String(right[0]).localeCompare(String(left[0])))
    .map(([date, items]) => {
      const sorted = [...items].sort(
        (left, right) => new Date(right.changedAt).getTime() - new Date(left.changedAt).getTime()
      );
      const notable = sorted.filter((event) => !NOISE_CHANGE_TYPES.has(event.changeType));
      const extras = notable.length
        ? sorted.filter((event) => NOISE_CHANGE_TYPES.has(event.changeType))
        : sorted.slice(3);
      const eventsForDay = notable.length ? notable : sorted.slice(0, 3);
      return {
        date,
        events: eventsForDay,
        extras,
        extraCount: extras.length,
      };
    });
}
